// extracted by mini-css-extract-plugin
export default {"message":"KO78W9","message--help":"g7g9yp"};